import type {
  NavigationAction,
  PlatformComponentProps,
} from "@b2bportal/core-types";
import type { PageComponentProps } from "@b2bportal/core-ui";
import type {
  useAvailabilityPageContainer,
  useAvailabilityPageRoute,
} from "./hooks";

export type AvailabilityPageHookProps = ReturnType<
  typeof useAvailabilityPageRoute
>;

export type AvailabilityPageFetchProps = ReturnType<
  typeof useAvailabilityPageRoute
>;

export type AvailabilityPageContainerProps = ReturnType<
  typeof useAvailabilityPageRoute
> &
  NavigationAction;

export type AvailabilityPageProps = ReturnType<
  typeof useAvailabilityPageContainer
> &
  PlatformComponentProps &
  PageComponentProps;

export const ShopMode = {
  LIST: "LIST",
  MAP: "MAP",
} as const;

export type ShopMode = keyof typeof ShopMode;
